import { connect } from "react-redux";
import { withTranslation } from "react-i18next";
import * as pointChangeHistoryAction from "../../../../actions/pointChangeHistoryAction";
import PointChangeHistory from "./PointChangeHistory";

const mapStateToProps = (state) => {
  return {
    pointChangeHistoryReducer: state.pointChangeHistoryReducer,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getListPointChangeHistory: (params) =>
      dispatch(pointChangeHistoryAction.getListPointChangeHistory(params)),
  };
};

export default withTranslation()(
  connect(mapStateToProps, mapDispatchToProps)(PointChangeHistory)
);
